import SessionsService from "@/services/SessionsService";

import {fulfilledState, pendingState, rejectedState, resError} from "@helpers";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

export const getCertificationSessions = createAsyncThunk(
  "certification/sessions",
  async (params, {rejectWithValue}) => {
    try {
      const response = await SessionsService.getCertificationSessions(params);

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

export const getScenarioSessions = createAsyncThunk(
  "scenario/sessions",
  async (params, {rejectWithValue}) => {
    try {
      const response = await SessionsService.getScenarioSessions(params);

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

export const getProductSessions = createAsyncThunk(
  "product/sessions",
  async (params, {rejectWithValue}) => {
    try {
      const response = await SessionsService.getProductSessions(params);

      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

const initialState = {
  data: [],
  sort: {value: "created_at", direction: "desc"},
  search: "",
  page: 1,
  size: 5,
  totalData: null,
  totalPages: null,
  typeId: 0,
  selectedData: null,
  errors: null,
  error: "",
  status: "",
};

const sessionsSlice = createSlice({
  name: "sessions",
  initialState,
  reducers: {
    setErrors(state, action) {
      state.errors = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setStatus(state, action) {
      state.status = action.payload;
    },
    setData(state, action) {
      state.data = action.payload;
    },
    setSelectedData(state, action) {
      state.selectedData = action.payload;
    },
    setSearch(state, action) {
      state.search = action.payload;
      state.page = 1;
    },
    setPage(state, action) {
      state.page = Math.max(1, action.payload);
    },
    setTypeId(state, action) {
      state.typeId = action.payload;
    },
    setSize(state, action) {
      state.size = action.payload;
    },
    setSort(state, action) {
      state.sort = action.payload;
    },
    setTotalPages(state, action) {
      state.totalPages = action.payload;
    },
    setTotalData(state, action) {
      state.totalData = action.payload;
    },
    decrementTotalData(state) {
      state.totalData -= 1;
    },
    clearTable() {
      return initialState;
    },
    clearData(state) {
      state.data = [];
      state.totalData = null;
      state.totalPages = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getScenarioSessions.pending, (state) => {
        pendingState(state);
      })
      .addCase(getScenarioSessions.fulfilled, (state, action) => {
        state.data = action.payload.data.map((session) => ({
          ...session,
          title: session.title || session.scenario,
        }));
        state.totalData = action.payload.total
          ? action.payload.total
          : state.totalData;
        state.totalPages = action.payload.total
          ? Math.ceil(action.payload.total / state.size)
          : state.totalPages;
        fulfilledState(state);
      })
      .addCase(getScenarioSessions.rejected, (state, action) => {
        rejectedState(state, action);
      })

      .addCase(getProductSessions.pending, (state) => {
        pendingState(state);
      })
      .addCase(getProductSessions.fulfilled, (state, action) => {
        state.data = action.payload.data.map((session) => ({
          ...session,
          title: session.title || session.product,
        }));
        state.totalData = action.payload.total
          ? action.payload.total
          : state.totalData;
        state.totalPages = action.payload.total
          ? Math.ceil(action.payload.total / state.size)
          : state.totalPages;
        fulfilledState(state);
      })
      .addCase(getProductSessions.rejected, (state, action) => {
        rejectedState(state, action);
      })

      .addCase(getCertificationSessions.pending, (state) => {
        pendingState(state);
      })
      .addCase(getCertificationSessions.fulfilled, (state, action) => {
        state.data = action.payload.data.map((session) => ({
          ...session,
          title: session.title || session.scenario,
        }));
        state.totalData = action.payload.total
          ? action.payload.total
          : state.totalData;
        state.totalPages = action.payload.total
          ? Math.ceil(action.payload.total / state.size)
          : state.totalPages;
        fulfilledState(state);
      })
      .addCase(getCertificationSessions.rejected, (state, action) => {
        rejectedState(state, action);
      });
  },
});

export const {
  setTypeId,
  setPage,
  setSort,
  clearTable,
  setTotalPages,
  setErrors,
  setError,
  setSize,
  setStatus,
  setSelectedData,
  clearData,
  setData,
  setSearch,
  setTotalData,
  decrementTotalData,
} = sessionsSlice.actions;
export default sessionsSlice.reducer;
